import { render, staticRenderFns } from "./Send.vue?vue&type=template&id=b2496006"
import script from "./Send.vue?vue&type=script&lang=js"
export * from "./Send.vue?vue&type=script&lang=js"
import style0 from "./Send.vue?vue&type=style&index=0&id=b2496006&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports